Ext.define('SA.NumberFormatter', {
    statics: {
        forAttribute(attribute) {
            var withDollarSign = SA.data.AttributesCache.isCurrency(attribute),
                withPercentSign = SA.data.AttributesCache.isPercent(attribute);

            return new SA.NumberFormatter({withDollarSign, withPercentSign});
        }
    },

    constructor({decimals = 0, power = 0, withDollarSign = false, withPercentSign = false} = {}) {
        this.decimals = decimals;
        this.power = power;
        this.withDollarSign = withDollarSign;
        this.withPercentSign = withPercentSign;
    },

    format(value) {
        var isNegative = value < 0;

        value = Math.abs(value);
        value = SA.PowersOfThousand.toFixed({value, decimals: this.decimals, power: this.power});
        value = this.withDollarSign ? `$${value}` : value;
        value = this.withPercentSign ? `${value}%` : value;
        value = isNegative ? `−${value}` : value; 

        return value;
    },

    set(params) {
        return new SA.NumberFormatter({...this, ...params});
    }
});